<ion-grid>
  
  <!-- Loading spinner -->
  <ion-row *ngIf="loading && !error" class="ion-justify-content-center ion-align-items-center">
    <ion-spinner name="circular"></ion-spinner>
  </ion-row>

  <!-- Error message -->
  <ion-row *ngIf="error" class="ion-justify-content-center">
    <ion-col size="12">
      <ion-item color="warning" lines="none">
        <ion-icon name="alert-circle" slot="start"></ion-icon>
        <ion-label>
          {{ error }}
        </ion-label>
      </ion-item>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="!loading && !error">
    <ion-card>
      <ion-card-header>
        <ion-card-title>Factory Specs vs. Current State</ion-card-title>
      </ion-card-header>

      <ion-card-content>
        
      </ion-card-content>
    </ion-card>

    <ion-card>
      <ion-card-header>
        <ion-card-title>Factory Specs vs. Current State</ion-card-title>
      </ion-card-header>

      <!-- Warning Alert -->
      <ion-item *ngIf="!allElementsHeating" color="warning" lines="none">
        <ion-icon name="warning" slot="start"></ion-icon>
        <ion-label>Warning: Not all elements are currently heating</ion-label>
      </ion-item>

      <!-- Voltages and Amperages Table -->
      <ion-card-content>
        <ion-list>
          <ion-item>
            <ion-label>
              <ion-grid class="specs-grid">
                <ion-row>
                  <ion-col></ion-col>
                  <ion-col>Factory Spec</ion-col>
                  <ion-col>Current State</ion-col>
                </ion-row>
                <!-- <ion-row>
                  <ion-col>Voltage 1</ion-col>
                  <ion-col>{{ diagnostics.v1.factorySpec || 'N/A' }} V</ion-col>
                  <ion-col>{{ diagnostics.v1.value }} V</ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>Voltage 2</ion-col>
                  <ion-col>{{ diagnostics.v2.factorySpec || 'N/A' }} V</ion-col>
                  <ion-col>{{ diagnostics.v2.value }} V</ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>Voltage 3</ion-col>
                  <ion-col>{{ diagnostics.v3.factorySpec || 'N/A' }} V</ion-col>
                  <ion-col>{{ diagnostics.v3.value }} V</ion-col>
                </ion-row> -->
                <ion-row>
                  <ion-col>Amperage 1</ion-col>
                  <ion-col>{{ diagnostics.a1.factorySpec || 'N/A' }} amps</ion-col>
                  <ion-col>{{ diagnostics.a1.value }} amps</ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>Amperage 2</ion-col>
                  <ion-col>{{ diagnostics.a2.factorySpec || 'N/A' }} amps</ion-col>
                  <ion-col>{{ diagnostics.a2.value }} amps</ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>Amperage 3</ion-col>
                  <ion-col>{{ diagnostics.a3.factorySpec || 'N/A' }} amps</ion-col>
                  <ion-col>{{ diagnostics.a3.value }} amps</ion-col>
                </ion-row>
              </ion-grid>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>
  </ion-row>

  <!-- Content row - hidden while loading or error -->
  <ion-row *ngIf="!loading && !error">
    <!-- <ion-card>
      <ion-card-header>
        <ion-card-title>Factory Specs vs. Current State</ion-card-title>
      </ion-card-header>

      <ion-item *ngIf="!allElementsHeating" color="warning" lines="none">
        <ion-icon name="warning" slot="start"></ion-icon>
        <ion-label>Warning: Not all elements are currently heating</ion-label>
      </ion-item>

      <ion-card-content>
        <ion-list>
          <ion-item>
            <ion-label>
              <ion-grid class="specs-grid">
                <ion-row>
                  <ion-col></ion-col>
                  <ion-col>Factory Spec</ion-col>
                  <ion-col>Current State</ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>Amperage 1</ion-col>
                  <ion-col>{{ diagnostics.a1.factorySpec || 'N/A' }} amps</ion-col>
                  <ion-col>{{ diagnostics.a1.value }} amps</ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>Amperage 2</ion-col>
                  <ion-col>{{ diagnostics.a2.factorySpec || 'N/A' }} amps</ion-col>
                  <ion-col>{{ diagnostics.a2.value }} amps</ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>Amperage 3</ion-col>
                  <ion-col>{{ diagnostics.a3.factorySpec || 'N/A' }} amps</ion-col>
                  <ion-col>{{ diagnostics.a3.value }} amps</ion-col>
                </ion-row>
              </ion-grid>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card> -->
    
    <!-- Diagnostic Checks Card -->
    <ion-card>
      <ion-card-header>
        <ion-card-subtitle>System Checks</ion-card-subtitle>
      </ion-card-header>
      
      <ion-list>
        <!-- <ion-item>
          <ion-icon [name]="diagnostics.buildingVoltageOk ? 'checkmark-circle' : 'alert-circle'" 
                    [color]="diagnostics.buildingVoltageOk ? 'success' : 'danger'"
                    slot="start">
          </ion-icon>
          <ion-label>
            Building voltage relative to kiln spec
            <p>{{ diagnostics.buildingVoltageOk ? 'OK' : 'Check Required' }}</p>
          </ion-label>
        </ion-item> -->

        <ion-item>
          <ion-icon [name]="diagnostics.wireSizeOk ? 'checkmark-circle' : 'alert-circle'"
                    [color]="diagnostics.wireSizeOk ? 'success' : 'danger'"
                    slot="start">
          </ion-icon>
          <ion-label>
            Wire size adequate
            <ion-icon 
              name="information-circle-outline" 
              color="medium" 
              class="info-icon"
              (click)="presentWireSizeInfo($event)">
            </ion-icon>
            <p>{{ diagnostics.wireSizeOk ? 'OK' : 'Check Required' }}</p>
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-icon [name]="diagnostics.allZonesEnergizing ? 'checkmark-circle' : 'alert-circle'"
                    [color]="diagnostics.allZonesEnergizing ? 'success' : 'danger'"
                    slot="start">
          </ion-icon>
          <ion-label>
            All zones energizing
            <ion-icon 
              name="information-circle-outline" 
              color="medium" 
              class="info-icon"
              (click)="presentAllZonesInfo($event)">
            </ion-icon>
            <p>{{ diagnostics.allZonesEnergizing ? 'Yes' : 'No' }}</p>
            <p *ngIf="!diagnostics.allZonesEnergizing">Non-energized zones: {{diagnostics.nonEnergizedZones}}</p>
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-icon [name]="diagnostics.controllerOutputsOk ? 'checkmark-circle' : 'alert-circle'" 
                    [color]="diagnostics.controllerOutputsOk ? 'success' : 'danger'"
                    slot="start">
          </ion-icon>
          <ion-label>
            Controller outputs powering
            <ion-icon 
              name="information-circle-outline" 
              color="medium" 
              class="info-icon"
              (click)="presentControllerOutputsInfo($event)">
            </ion-icon>
            <p>{{ diagnostics.controllerOutputsOk ? 'OK' : 'Check Required' }}</p>
            <p *ngIf="!diagnostics.controllerOutputsOk">Non-energized zones: {{diagnostics.lowPowerOutputs}}</p>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-card>
    
    <!-- Estimates Card -->
    <ion-card>
      <ion-card-header>
        <ion-card-subtitle>Performance Estimates</ion-card-subtitle>
      </ion-card-header>
      
      <ion-list>
        <ion-item>
          <ion-label>
            <h2>Wattage Drop <i>((spec - current) / spec)</i></h2>
            <p>{{ diagnostics.wattageDrop || 'N/A' }}</p>
          </ion-label>
        </ion-item>
        
        <ion-item>
          <ion-label>
            <h2>Estimated Max Temperature</h2>
            <p><i>Not implemented</i></p>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-card>
  </ion-row>
</ion-grid>